import DefaultMapper from '../../dataProvider/DefaultMapper';

class BlackWhiteListMapper extends DefaultMapper {

	mapResource({ resource }) {
		return 'system/blackwhitelists';
	}

	prepareUpdate({ params, options }) {
		super.prepareUpdate(...arguments);
		const filteredParams = Object.assign({}, params.data);
		delete filteredParams.id;
		delete filteredParams.creationDateTime;
		options.body = JSON.stringify(filteredParams);
	}

};

export default BlackWhiteListMapper;
